import { type PropsWithChildren } from 'react'

import PrimaryColorProvider from '../primary-color'

const MantineProvider = (props: PropsWithChildren) => {
  const { children } = props

  return <PrimaryColorProvider>{children}</PrimaryColorProvider>
}

export default MantineProvider
